import { tenureDeleteApi } from "../../api/tenure/tenureDeleteApi"

type PayloadShape = Parameters<typeof tenureDeleteApi>[0]

export async function tenureDeleteService(payload: PayloadShape, token: string) {
	return await tenureDeleteApi(payload, token)
}
